export default {
    formateDate(time) {
        if (!time) {
            return '';
        }
        let date = new Date(time);
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    },
    pagination(data, calllback) {
        let page = {
            onChange: (current) => {
                calllback(current);
            },
            current: data.result.page,
            pageSize: data.result.page_size,
            total: data.result.total_count,
            showTotal: () => {
                return `一共${data.result.total_count}`
            },
            showQuickJumper: true
        }
        return page;
    }
}